import { render, staticRenderFns } from "./BaseSwayOfferPanel.vue?vue&type=template&id=6680a8ab&"
import script from "./BaseSwayOfferPanel.vue?vue&type=script&lang=js&"
export * from "./BaseSwayOfferPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports